import { NextPage } from "next";

import { NotFound } from "@components/legacy";

import { ArticleView, ArticleViewProps } from "../Article";
import { CategoryView, CategoryViewProps } from "../Category";
import { CollectionView, CollectionViewProps } from "../Collection";

type DynamicViewProps =
  | ({ viewType: "article" } & ArticleViewProps)
  | ({ viewType: "category" } & CategoryViewProps)
  | ({ viewType: "collection" } & CollectionViewProps);

export const DynamicView: NextPage<DynamicViewProps> = (props) => {
  const { viewType, ...otherProps } = props;
  if (viewType === "article") {
    return <ArticleView {...otherProps} />;
  }
  if (viewType === "category") {
    return <CategoryView {...otherProps} />;
  }
  if (viewType === "collection") {
    return <CollectionView {...otherProps} />;
  }
  return <NotFound />;
};
